var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { getUiOptions } from "../utils/";

var defaultProps = {
    defaultFormData: {
        "mediaId": undefined,
        "media": {
            "mediaType": undefined
        }
    },
    defaultOptions: {
        "layout": "media",
        "format": "2:1",
        "editable": true,
        "hideable": true,
        "deletable": true,
        "buttons": [{
            "type": "upload"
        }]
    },
    defaultSchema: {
        "type": "object",
        "properties": {
            "mediaId": {
                "type": "string",
                "readonly": true
            },
            "media": {
                "type": "object",
                "properties": {
                    "mediaType": {
                        "type": "string",
                        "readonly": true
                    },
                    "uniqueId": {
                        "type": "string",
                        "readonly": true
                    }
                }
            },
            "cropdata": {
                "type": "object",
                "properties": {
                    "x": {
                        "type": "number",
                        "readonly": true
                    },
                    "y": {
                        "type": "number",
                        "readonly": true
                    },
                    "width": {
                        "type": "number",
                        "readonly": true
                    },
                    "height": {
                        "type": "number",
                        "readonly": true
                    }
                }
            },
            "focalpoint": {
                "type": "object",
                "properties": {
                    "x": {
                        "type": "number",
                        "readonly": true
                    },
                    "y": {
                        "type": "number",
                        "readonly": true
                    }
                }
            }
        }
    }
};

var getSchema = function getSchema(props) {
    var schema = props.schema,
        defaultSchema = props.defaultSchema;
    var mediaType = schema.mediaType,
        properties = schema.properties;


    var fieldSchema = defaultSchema;

    if (mediaType) {
        fieldSchema = _extends({}, fieldSchema, {
            properties: _extends({}, fieldSchema.properties, {
                mediaType: _extends({}, fieldSchema.properties.mediaType, {
                    default: mediaType
                })
            })
        });
    }

    if (properties) {

        fieldSchema = _extends({}, fieldSchema, {
            properties: _extends({}, fieldSchema.properties, properties)
        });
    }

    return fieldSchema;
};

function getUiSchema(props) {
    var formData = props.formData,
        schema = props.schema,
        uiSchema = props.uiSchema,
        defaultOptions = props.defaultOptions;


    var options = getUiOptions(uiSchema);

    var fieldset = [];

    if (!options.fieldset && schema.properties) {

        Object.keys(schema.properties).map(function (name) {

            var type = schema.properties[name] && schema.properties[name].type || undefined;

            if (type === "object") {
                fieldset.push(name);
            }
        });
    }

    var cropdata = options.cropdata || schema.cropdata || false;
    var focalpoint = options.focalpoint || schema.focalpoint || false;

    if (cropdata) {
        fieldset.push('cropdata');
    }

    if (focalpoint) {
        fieldset.push('focalpoint');
    }

    if (fieldset.length) {
        options.nav = true;
        options.fieldset = fieldset;
    }

    return {
        "ui:options": _extends({}, defaultOptions, options, {
            "imageUrl": formData && formData.media && formData.media.imageUrl,
            "preview": formData
        })
    };
}

function getFormData(props) {
    var formData = props.formData,
        defaultFormData = props.defaultFormData;


    formData = _extends({}, defaultFormData, formData);

    return formData;
}

export default function getField(props) {

    props = _extends({}, defaultProps, props);

    var schema = getSchema(props);
    var uiSchema = getUiSchema(_extends({}, props, { schema: schema }));
    var formData = getFormData(_extends({}, props, { schema: schema, uiSchema: uiSchema }));

    return _extends({}, props, {
        schema: schema,
        uiSchema: uiSchema,
        formData: formData
    });
}